import React, { Component } from "react";
import { Navigate,Link } from "react-router-dom";
import UserService from "../services/user.service";
import "./styles.profile.css";



export default class ControlPagos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: null,
      userReady: false,
      currentUser: null,
      content:null,
      mensajes:null,
      novedades:[],
      estudiantes:[],
      reportes:[],
   
     
      seleccion:null


    };
  }

  componentDidMount() {


   

    //utiliza el token para conseguir datos de usuario
    UserService.getadControlPagos().then(
      response => {
        this.setState({
          content: response.data,
          estudiantes:response.data.estudiantes,
          reportes:response.data.reportes,

          userReady: true
        });

        console.log("Esto del control de pagos",response.data)

      },
      error => {

//si no lo consigues, solicita login

        this.setState({
          userReady: false,
          content:
            (error.response && error.response.data) ||
            error.message ||
            error.toString()
        });
      }
    );
   

  
  }


  seleccionarestudiante(id){

    console.log(id)

   let filtrardo = this.state.reportes.filter((item) => item.userid === id)

    console.log(filtrardo)
    this.setState({

      reportes:filtrardo
    });

  }




  render() {


  
    if (this.state.redirect) {
        return <Navigate to={this.state.redirect} />
      }
 
 
   
    return (
        <div>



{this.state.userReady?
<div className="hero">
  <header>
    <nav className="navbar">
      <div className="navbar__brand">
      <Link to={"/profile"} >

        <img src="../img/logo_escuela_aye_sd.png" alt="logo" className="brand__logo" />  <p><i className="fa fa-undo" aria-hidden="true" />
Regresar
 </p>    </Link >

      </div>
      <div className="navbar__nav__items">
        <div className="nav__item">
      
    
        </div>

      </div>
    </nav>
  </header>
        
      <div className="hero__bg__image__container">
        <img src="../img/fondoweb.png" alt="fondo" className="hero__bg__image" />
      </div>
      
      <div className="hero__bg__overlay" />
      <div className="hero__card2 container">
       
      
        <div className="card card-container ">
        <h3><i className="fas fa-shopping-cart" />  Control Pagos: </h3>

        
  
        </div>

        <div>

        <select onChange={(e)=> this.seleccionarestudiante(e.target.value)}>
        <option >Seleccionar Estudiante</option>

        {this.state.estudiantes.length >0? this.state.estudiantes.map((item) =>

 <option value={item.uuid} >{item.name}</option>

        )

       :null}
      </select>
      </div>

        <table className="table table-dark">
  <thead>
    <tr>
      <th scope="col">Fecha</th>
      <th scope="col">Nombre</th>

      <th scope="col">Curso</th>
      <th scope="col">Concepto</th>

      <th scope="col">Monto Pagado</th>
           <th scope="col">Cuota</th>
 <th scope="col">Estatus</th>
      <th scope="col">Nota</th>

    </tr>
  </thead>
  <tbody>
   
   {this.state.reportes.length >0? this.state.reportes.map((item)=>
   
   <tr className={item.estatus==="si"?"btn-success":""} >
      <th scope="row">{item.created_at}</th>
      <td>{item.nombrecompleto}</td>

     
      <td>{item.idcurso}</td>

      <td>
 


      {item.titulo}
      
      </td>
      <td>   
      {item.pagousd>0 ? <p>{item.pagousd} USD</p>:<p>{item.pagobs} Bs</p>}


      
      </td>
     
        <td>
 


 {item.cuota}
 
 </td> 
 <td>
        {item.estatus==="si" && <p className="btn btn-success">Verificado</p>}
        {item.estatus==="no" && <p className="btn btn-danger">No Validado</p>}
        {item.estatus===null && <p className="btn btn-info">Pendiente</p>}

        
        </td>
 
 <td>
 


 {item.nota}
 
 </td>
    </tr>
   
   
   
   ):<tr>No has realizado ningun pago</tr>}
   
    
    
  </tbody>
</table>

      </div>
    </div>:
<div>
    

      <Link to={"/profile"} >

        <p><i className="fa fa-undo" aria-hidden="true" />
Regresar
 </p>    </Link >

     


</div>}


        </div>
    );
  }
}
